'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import type { Gender } from './types';
import styles from './GenderToggle.module.css';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

type GenderToggleProps = {
  value: Gender;
  onChange: (gender: Gender) => void;
  className?: string;
};

export const GenderToggle: React.FC<GenderToggleProps> = ({
  value,
  onChange,
  className,
}) => {
  const t = useTranslations('performance-lab');
  const isMen = value === 'men';
  const activeIndex = isMen ? 0 : 1;
  const menLabel = t('leaderboard.gender.men');
  const womenLabel = t('leaderboard.gender.women');

  return (
    <div
      className={cx(styles.track, className)}
      role="tablist"
      aria-label={t('leaderboard.gender.aria')}
    >
      <div
        className={styles.thumb}
        data-active-index={activeIndex}
        aria-hidden="true"
      />
      <span
        className={styles.tabLabel}
        data-active={isMen}
        data-side="left"
        aria-hidden="true"
      >
        {menLabel}
      </span>
      <span
        className={styles.tabLabel}
        data-active={!isMen}
        data-side="right"
        aria-hidden="true"
      >
        {womenLabel}
      </span>
      <button
        className={styles.tabHit}
        type="button"
        role="tab"
        aria-selected={isMen}
        data-side="left"
        onClick={() => onChange('men')}
        aria-label={menLabel}
      />
      <button
        className={styles.tabHit}
        type="button"
        role="tab"
        aria-selected={!isMen}
        data-side="right"
        onClick={() => onChange('women')}
        aria-label={womenLabel}
      />
    </div>
  );
};
